import { createSlice } from '@reduxjs/toolkit';

import axios from 'axios';
import { dispatch } from '../index';

const initialState = {
    error: null,
    campaignInfo: null,
    creativeList: null,
    creativeResultCount: 0,
    subscribedCreativeTopic: false,
    creativeProgress: null,
    textList: null,
    textResultCount: 0,
    subscribedTextTopic: false,
    textProgress: null,
    packageList: null,
    packageResultCount: 0,
    textEditing: null,
    creativeFailedGeneration: null,
    textFailedGeneration: null
};

// ==============================|| SLICE - CAMPAIGN ||============================== //

const slice = createSlice({
    name: 'campaign',
    initialState,
    reducers: {
        hasError(state, action) {
            if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'login'
            } else if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'forbidden'
            } else {
                state.error = action.payload;
            }
        },
        setCampaignInfo(state, action) {
            state.campaignInfo = action.payload;
            state.creativeProgress = action.payload.imageProgress;
            state.textProgress = action.payload.textProgress;     
        },
        creativeListInit(state, action) {
            state.creativeList = action.payload.creativeList;
            state.creativeResultCount = action.payload.total;
        },
        creativeListAppend(state, action) {
            state.creativeList = [...state.creativeList, ...action.payload.creativeList];
        },
        setSubscribedCreativeTopic(state, action) {
            state.subscribedCreativeTopic = action.payload;
        },
        setCreativeProgress(state, action) {
            state.creativeProgress = action.payload;
        },
        setCreativeFailedGeneration(state, action) {
            state.creativeFailedGeneration = action.payload;
        },
        textListInit(state, action) {
            state.textList = action.payload.promotionTextList;
            state.textResultCount = action.payload.total;
        },
        textListAppend(state, action) {
            state.textList = [...state.textList, ...action.payload.promotionTextList];
        },
        setSubscribedTextTopic(state, action) {
            state.subscribedTextTopic = action.payload;
        },
        setTextProgress(state, action) {
            state.textProgress = action.payload;
        },
        setTextEditing(state, action) {
            state.textEditing = action.payload;
        },
        packageListInit(state, action) {
            state.packageList = action.payload.packageList;
            state.packageResultCount = action.payload.total;
        },
        packageListAppend(state, action) {
            state.packageList = [...state.packageList, ...action.payload.packageList];
        },
        resetCreativeInfo(state) {
            state.creativeList = null;
            state.creativeResultCount = 0;
        },
        resetTextInfo(state) {
            state.textList = null;
            state.textResultCount = 0;
        },
        resetPackageInfo(state) {
            console.log('clear package related param.');
            state.packageList = null;
            state.packageResultCount = 0;
        },
        reset(state) {
            state.error = null;
            state.campaignInfo = null;
            state.creativeList = null;
            state.creativeResultCount = 0;
            state.creativeProgress = null;
            state.creativeFailedGeneration = null;
            state.textList = null;
            state.textResultCount = 0;
            state.textProgress = null;
            state.textFailedGeneration = null;
            state.packageList = null;
            state.packageResultCount = 0;
            state.textEditing = null;
        }
    }
});

export default slice.reducer;

export const { 
    setCreativeSubscription, 
    getCreativeSubscription, 
    setSubscribedCreativeTopic, 
    setCreativeProgress, 
    setCreativeFailedGeneration,
    setTextSubscription, 
    getTextSubscription, 
    setSubscribedTextTopic, 
    setTextProgress,
    setTextFailedGeneration
} = slice.actions;

// An action to start stomp connection.
export const connectStomp = (gentype, id) => ({ type: 'connect', gentype, id });

// An action to disconnect stomp connection.
export const disconnectStomp = () => ({ type: 'disconnect' });

// An action to unsubscribe stomp topic.
export const unsubscribeTopic = (gentype, id) => ({ type: 'unsubscribe', gentype, id});

export function getCampaignDetail(data, callback) {
    return async () => {
        try {
            const response = await axios.get(`/api/campaign/details/${data}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setCampaignInfo(response.data.campaign));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getCreativeList(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/creative/list', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (data.currentPage === 1) {
                dispatch(slice.actions.creativeListInit(response.data));
            } else if (data.currentPage > 1) {
                dispatch(slice.actions.creativeListAppend(response.data));
            }

            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function generateMoreCreative(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/creative/generate-more', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function duplicateCreative(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/creative/duplicate', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function updateCreative(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/creative/update', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getTextList(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/text/list', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (data.currentPage === 1) {
                dispatch(slice.actions.textListInit(response.data));
            } else if (data.currentPage > 1) {
                dispatch(slice.actions.textListAppend(response.data));
            }

            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function generateMoreText(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/text/generate-more', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function duplicateText(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/text/duplicate', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function updateText(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/text/update', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getPackageList(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/package/list', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (data.currentPage === 1) {
                dispatch(slice.actions.packageListInit(response.data));
            } else if (data.currentPage > 1) {
                dispatch(slice.actions.packageListAppend(response.data));
            }

            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function updatePackage(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/package/update', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function updateTextEditing(data) {
    return () => {
        dispatch(slice.actions.setTextEditing(data));
    };
}

export function clearCreativeInfo(data, callback) {
    return () => {
        dispatch(slice.actions.resetCreativeInfo());
        if (callback) {
            callback();
        }
    };
};

export function clearTextInfo(data, callback) {
    return () => {
        dispatch(slice.actions.resetTextInfo());
        if (callback) {
            callback();
        }
    };
};

export function clearPackageInfo(data, callback) {
    return () => {
        dispatch(slice.actions.resetPackageInfo());
        if (callback) {
            callback();
        }
    };
};

export function clearStore(data, callback) {
    return () => {
        dispatch(slice.actions.reset());
        if (callback) {
            callback();
        }
    };
}
